import { CommonModule } from '@angular/common';
import { Component, ElementRef, QueryList, ViewChildren, ChangeDetectorRef } from '@angular/core';
import { SidebarService } from '../../services/sidebar.service';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { SafeHtmlPipe } from '../../pipe/safe-html.pipe';
import { TPipe } from '../../pipe/t.pipe';
import { LanguageSwitchComponent } from '../../components/common/language-switch/language-switch.component';
import { combineLatest, Subscription } from 'rxjs';

type NavItem = {
  name: string;
  icon: string;
  path?: string;
  new?: boolean;
  subItems?: { name: string; path: string; pro?: boolean; new?: boolean }[];
};

@Component({
  selector: 'app-sidebar',
  imports: [
    CommonModule,
    RouterModule,
    SafeHtmlPipe,
    TPipe,
    LanguageSwitchComponent,
  ],
  templateUrl: './app-sidebar.component.html',
})
export class AppSidebarComponent {

  // ── Icônes SVG réutilisées ────────────────────────────────────────────
  private static readonly ICON_DASHBOARD = `<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.5 3.25C4.25736 3.25 3.25 4.25736 3.25 5.5V8.99998C3.25 10.2426 4.25736 11.25 5.5 11.25H9C10.2426 11.25 11.25 10.2426 11.25 8.99998V5.5C11.25 4.25736 10.2426 3.25 9 3.25H5.5ZM4.75 5.5C4.75 5.08579 5.08579 4.75 5.5 4.75H9C9.41421 4.75 9.75 5.08579 9.75 5.5V8.99998C9.75 9.41419 9.41421 9.74998 9 9.74998H5.5C5.08579 9.74998 4.75 9.41419 4.75 8.99998V5.5ZM5.5 12.75C4.25736 12.75 3.25 13.7574 3.25 15V18.5C3.25 19.7426 4.25736 20.75 5.5 20.75H9C10.2426 20.75 11.25 19.7427 11.25 18.5V15C11.25 13.7574 10.2426 12.75 9 12.75H5.5ZM4.75 15C4.75 14.5858 5.08579 14.25 5.5 14.25H9C9.41421 14.25 9.75 14.5858 9.75 15V18.5C9.75 18.9142 9.41421 19.25 9 19.25H5.5C5.08579 19.25 4.75 18.9142 4.75 18.5V15ZM12.75 5.5C12.75 4.25736 13.7574 3.25 15 3.25H18.5C19.7426 3.25 20.75 4.25736 20.75 5.5V8.99998C20.75 10.2426 19.7426 11.25 18.5 11.25H15C13.7574 11.25 12.75 10.2426 12.75 8.99998V5.5ZM15 4.75C14.5858 4.75 14.25 5.08579 14.25 5.5V8.99998C14.25 9.41419 14.5858 9.74998 15 9.74998H18.5C18.9142 9.74998 19.25 9.41419 19.25 8.99998V5.5C19.25 5.08579 18.9142 4.75 18.5 4.75H15ZM15 12.75C13.7574 12.75 12.75 13.7574 12.75 15V18.5C12.75 19.7426 13.7574 20.75 15 20.75H18.5C19.7426 20.75 20.75 19.7427 20.75 18.5V15C20.75 13.7574 19.7426 12.75 18.5 12.75H15ZM14.25 15C14.25 14.5858 14.5858 14.25 15 14.25H18.5C18.9142 14.25 19.25 14.5858 19.25 15V18.5C19.25 18.9142 18.9142 19.25 18.5 19.25H15C14.5858 19.25 14.25 18.9142 14.25 18.5V15Z" fill="currentColor"></path></svg>`;
  private static readonly ICON_USERS = `<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 14.1526 4.3002 16.1184 5.61936 17.616C6.17279 15.3096 8.24852 13.5955 10.7246 13.5955H13.2746C15.7509 13.5955 17.8268 15.31 18.38 17.6167C19.6996 16.119 20.5 14.153 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5ZM17.0246 18.8566V18.8455C17.0246 16.7744 15.3457 15.0955 13.2746 15.0955H10.7246C8.65354 15.0955 6.97461 16.7744 6.97461 18.8455V18.856C8.38223 19.8895 10.1198 20.5 12 20.5C13.8798 20.5 15.6171 19.8898 17.0246 18.8566ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM11.9991 7.25C10.8847 7.25 9.98126 8.15342 9.98126 9.26784C9.98126 10.3823 10.8847 11.2857 11.9991 11.2857C13.1135 11.2857 14.0169 10.3823 14.0169 9.26784C14.0169 8.15342 13.1135 7.25 11.9991 7.25ZM8.48126 9.26784C8.48126 7.32499 10.0563 5.75 11.9991 5.75C13.9419 5.75 15.5169 7.32499 15.5169 9.26784C15.5169 11.2107 13.9419 12.7857 11.9991 12.7857C10.0563 12.7857 8.48126 11.2107 8.48126 9.26784Z" fill="currentColor"></path></svg>`;
  private static readonly ICON_CUBE = `<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.665 3.75618C11.8762 3.65061 12.1247 3.65061 12.3358 3.75618L18.7807 6.97853L12.3358 10.2009C12.1247 10.3064 11.8762 10.3064 11.665 10.2009L5.22014 6.97853L11.665 3.75618ZM4.29297 8.19199V16.0946C4.29297 16.3787 4.45347 16.6384 4.70757 16.7654L11.25 20.0365V11.6512C11.1631 11.6205 11.0777 11.5843 10.9942 11.5425L4.29297 8.19199ZM12.75 20.037L19.2933 16.7654C19.5474 16.6384 19.7079 16.3787 19.7079 16.0946V8.19199L13.0066 11.5425C12.9229 11.5844 12.8372 11.6207 12.75 11.6515V20.037ZM13.0066 2.41453C12.3732 2.09783 11.6277 2.09783 10.9942 2.41453L4.03676 5.89316C3.27449 6.27429 2.79297 7.05339 2.79297 7.90563V16.0946C2.79297 16.9468 3.27448 17.7259 4.03676 18.1071L10.9942 21.5857L11.3296 20.9149L10.9942 21.5857C11.6277 21.9024 12.3732 21.9024 13.0066 21.5857L19.9641 18.1071C20.7264 17.7259 21.2079 16.9468 21.2079 16.0946V7.90563C21.2079 7.05339 20.7264 6.27429 19.9641 5.89316L13.0066 2.41453Z" fill="currentColor"></path></svg>`;
  private static readonly ICON_CAR = `<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19 17h2c.55 0 1-.45 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3A2.4 2.4 0 0 0 12 7H5c-.6 0-1.1.35-1.4.9L2.2 10.8A3.7 3.7 0 0 0 2 12v4c0 .55.45 1 1 1h2" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/><circle cx="7" cy="17" r="2" stroke="currentColor" stroke-width="1.6"/><path d="M9 17h6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/><circle cx="17" cy="17" r="2" stroke="currentColor" stroke-width="1.6"/></svg>`;
  private static readonly ICON_NETWORK = `<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 7.5h16A1.5 1.5 0 0 1 21.5 9v9a1.5 1.5 0 0 1-1.5 1.5H4A1.5 1.5 0 0 1 2.5 18V9A1.5 1.5 0 0 1 4 7.5Z" stroke="currentColor" stroke-width="1.6"/><path d="M8.5 7.5V6A1.5 1.5 0 0 1 10 4.5h4A1.5 1.5 0 0 1 15.5 6v1.5M2.5 12h19" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>`;
  private static readonly ICON_CARD = `<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="3" y="5.5" width="18" height="13" rx="2" stroke="currentColor" stroke-width="1.6"/><path d="M3 9.5h18M6.5 14.5h4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>`;
  private static readonly ICON_BANK = `<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 3.5 3.5 8v1.5h17V8L12 3.5ZM5.5 11v6M9.5 11v6M14.5 11v6M18.5 11v6M3.5 19.5h17" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
  private static readonly ICON_SETTINGS = `<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 15.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z" stroke="currentColor" stroke-width="1.6"/><path d="M19.4 12a7.4 7.4 0 0 0-.1-1.1l1.7-1.3-1.7-3-2 .8a7.3 7.3 0 0 0-1.9-1.1l-.3-2.1H9.9l-.3 2.1a7.3 7.3 0 0 0-1.9 1.1l-2-.8-1.7 3 1.7 1.3a7.4 7.4 0 0 0 0 2.2l-1.7 1.3 1.7 3 2-.8a7.3 7.3 0 0 0 1.9 1.1l.3 2.1h3.4l.3-2.1a7.3 7.3 0 0 0 1.9-1.1l2 .8 1.7-3-1.7-1.3c.06-.36.1-.73.1-1.1Z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/></svg>`;
  private static readonly ICON_BELL = `<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.5 9.5a5.5 5.5 0 0 1 11 0c0 4 1.5 5.5 1.5 5.5H5s1.5-1.5 1.5-5.5Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><path d="M10 18.5a2 2 0 0 0 4 0" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>`;

  // ── Navigation principale (modules métier Nawam) ──────────────────────
  // NOTE i18n : `name` porte une **clé** de traduction (cf. shared/i18n/messages).
  // Le template rend `{{ nav.name | t }}` — bascule FR/EN instantanée. Un libellé
  // non-migré (ex. les items « Démo ») passe tel quel via le repli sur la clé.
  navItems: NavItem[] = [
    {
      icon: AppSidebarComponent.ICON_DASHBOARD,
      name: 'nav.dashboard',
      path: '/',
    },
    {
      icon: AppSidebarComponent.ICON_USERS,
      name: 'group.usersAccess',
      subItems: [
        { name: 'nav.users', path: '/users' },
        { name: 'nav.roles', path: '/roles' },
        { name: 'nav.permissions', path: '/permissions' },
        { name: 'nav.assignments', path: '/role-assignments' },
      ],
    },
    {
      icon: AppSidebarComponent.ICON_CAR,
      name: 'group.fleetRentals',
      subItems: [
        { name: 'nav.owners', path: '/owners' },
        { name: 'nav.customers', path: '/customers' },
        { name: 'nav.driverLeads', path: '/driver-leads' },
        { name: 'nav.vehicles', path: '/vehicles' },
        { name: 'nav.options', path: '/options' },
        { name: 'nav.rentals', path: '/rentals' },
        { name: 'nav.invoices', path: '/invoices' },
      ],
    },
    {
      icon: AppSidebarComponent.ICON_NETWORK,
      name: 'group.operatorsNetwork',
      subItems: [
        { name: 'nav.operators', path: '/operators' },
        { name: 'nav.operatorRequests', path: '/change-requests' },
        // Deux granularités distinctes : le dossier gate le recrutement,
        // la pièce arme le suivi d'expiration. Cf. /operators/{id}#kyc.
        { name: 'nav.operatorKyc', path: '/operator-kyc' },
        { name: 'nav.kycDocuments', path: '/kyc' },
        { name: 'nav.zones', path: '/zones' },
        { name: 'nav.licensePricing', path: '/license-pricing' },
      ],
    },
    {
      icon: AppSidebarComponent.ICON_CARD,
      name: 'group.payments',
      subItems: [
        { name: 'nav.transactions', path: '/transactions' },
        { name: 'nav.paymentMethods', path: '/payment-methods' },
        { name: 'nav.wallets', path: '/wallets' },
      ],
    },
    {
      icon: AppSidebarComponent.ICON_BANK,
      name: 'group.treasury',
      subItems: [
        { name: 'nav.debts', path: '/debts' },
        { name: 'nav.withdrawals', path: '/withdrawals' },
        { name: 'nav.reconciliation', path: '/cash-reconciliation' },
        { name: 'nav.treasury', path: '/treasury' },
      ],
    },
    {
      icon: AppSidebarComponent.ICON_SETTINGS,
      name: 'group.configRules',
      subItems: [
        { name: 'nav.commissionGlobal', path: '/commission-config' },
        { name: 'nav.cancellationPolicies', path: '/cancellation-policies' },
        { name: 'nav.lateFees', path: '/late-fee-policies' },
        { name: 'nav.deposit', path: '/deposit-policy' },
      ],
    },
    {
      icon: AppSidebarComponent.ICON_BELL,
      name: 'nav.notifications',
      path: '/notifications',
    },
  ];

  // ── Démos du template TailAdmin (à supprimer en Phase 4) ──────────────
  othersItems: NavItem[] = [
    {
      icon: AppSidebarComponent.ICON_CUBE,
      name: 'Démo template',
      subItems: [
        { name: 'Calendrier', path: '/calendar' },
        { name: 'Profil', path: '/profile' },
        { name: 'Formulaires', path: '/form-elements' },
        { name: 'Tables', path: '/basic-tables' },
        { name: 'Page vierge', path: '/blank' },
        { name: 'Graphique ligne', path: '/line-chart' },
        { name: 'Graphique barres', path: '/bar-chart' },
        { name: 'Alertes', path: '/alerts' },
        { name: 'Avatars', path: '/avatars' },
        { name: 'Badges', path: '/badge' },
        { name: 'Boutons', path: '/buttons' },
        { name: 'Images', path: '/images' },
        { name: 'Vidéos', path: '/videos' },
      ],
    },
  ];

  openSubmenu: string | null | number = null;
  subMenuHeights: { [key: string]: number } = {};
  @ViewChildren('subMenu') subMenuRefs!: QueryList<ElementRef>;

  readonly isExpanded$;
  readonly isMobileOpen$;
  readonly isHovered$;

  private subscription: Subscription = new Subscription();

  constructor(
    public sidebarService: SidebarService,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) {
    this.isExpanded$ = this.sidebarService.isExpanded$;
    this.isMobileOpen$ = this.sidebarService.isMobileOpen$;
    this.isHovered$ = this.sidebarService.isHovered$;
  }

  ngOnInit() {
    // Subscribe to router events
    this.subscription.add(
      this.router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
          this.setActiveMenuFromRoute(this.router.url);
        }
      })
    );

    // Subscribe to combined observables to close submenus when all are false
    this.subscription.add(
      combineLatest([this.isExpanded$, this.isMobileOpen$, this.isHovered$]).subscribe(
        ([isExpanded, isMobileOpen, isHovered]) => {
          if (!isExpanded && !isMobileOpen && !isHovered) {
            // this.openSubmenu = null;
            // this.savedSubMenuHeights = { ...this.subMenuHeights };
            // this.subMenuHeights = {};
            this.cdr.detectChanges();
          } else {
            // Restore saved heights when reopening
            // this.subMenuHeights = { ...this.savedSubMenuHeights };
            // this.cdr.detectChanges();
          }
        }
      )
    );

    // Initial load
    this.setActiveMenuFromRoute(this.router.url);
  }

  ngOnDestroy() {
    // Clean up subscriptions
    this.subscription.unsubscribe();
  }

  isActive(path: string): boolean {
    return this.router.url === path;
  }

  toggleSubmenu(section: string, index: number) {
    const key = `${section}-${index}`;

    if (this.openSubmenu === key) {
      this.openSubmenu = null;
      this.subMenuHeights[key] = 0;
    } else {
      this.openSubmenu = key;

      setTimeout(() => {
        const el = document.getElementById(key);
        if (el) {
          this.subMenuHeights[key] = el.scrollHeight;
          this.cdr.detectChanges(); // Ensure UI updates
        }
      });
    }
  }

  onSidebarMouseEnter() {
    this.isExpanded$.subscribe(expanded => {
      if (!expanded) {
        this.sidebarService.setHovered(true);
      }
    }).unsubscribe();
  }

  private setActiveMenuFromRoute(currentUrl: string) {
    const menuGroups = [
      { items: this.navItems, prefix: 'main' },
      { items: this.othersItems, prefix: 'others' },
    ];

    menuGroups.forEach(group => {
      group.items.forEach((nav, i) => {
        if (nav.subItems) {
          nav.subItems.forEach(subItem => {
            if (currentUrl === subItem.path) {
              const key = `${group.prefix}-${i}`;
              this.openSubmenu = key;

              setTimeout(() => {
                const el = document.getElementById(key);
                if (el) {
                  this.subMenuHeights[key] = el.scrollHeight;
                  this.cdr.detectChanges(); // Ensure UI updates
                }
              });
            }
          });
        }
      });
    });
  }

  onSubmenuClick() {
    console.log('click submenu');
    this.isMobileOpen$.subscribe(isMobile => {
      if (isMobile) {
        this.sidebarService.setMobileOpen(false);
      }
    }).unsubscribe();
  }  

  
}
